import { hubOneOff } from '@/assets';

interface BottomCTAProps {
  hasSubscription: boolean;
}

export function BottomCTA({ hasSubscription }: BottomCTAProps) {
  if (!hasSubscription) return null;

  return (
    <div className="bg-[#d7cfc7] py-8 md:py-[80px] px-4">
      <div
        className="bg-white rounded-3xl mt-6 md:mt-12 text-purple-medium max-w-[1240px] mx-auto flex flex-col md:flex-row md:items-stretch md:gap-20"
        style={{ boxShadow: '0px 4px 20px 0px rgba(21, 93, 226, 0.18)' }}
      >
        <img src={hubOneOff} alt="Happy couple" className="w-full md:max-w-[445px] md:max-h-[321px] rounded-t-3xl md:rounded-t-none md:rounded-l-3xl" />
        <div className="flex flex-col justify-between md:min-h-[321px] p-6 md:py-12 md:pr-[100px]">
          <div>
            <h3 className="text-xl md:text-[32px] font-semibold leading-[1.2] mb-2">Need to remember this date next year too?</h3>
            <p className="text-base md:text-2xl leading-[1.2] md:leading-[1]">
              Birdie Gifts can keep up with your important gifting dates so you never miss a special occasion.
            </p>
          </div>
          <a href={hasSubscription ? "/one-off/1" : "/subscription/1"} target="_blank" className="bg-[#3d4e30] py-4 md:py-[18.5px] leading-[27px] text-base md:text-lg w-full text-white rounded-full font-semibold cursor-pointer mt-6 md:mt-0 text-center">
            {hasSubscription ? "Send Another Gift" : "Birdie Gifts Subscription"}
          </a>
        </div>
      </div>
    </div>
  );
}
